import React, { Component } from 'react';
import { BrowserRouter as Router, Route,  Switch, Redirect} from 'react-router-dom';
import { withRouter } from 'react-router'
import Home from './page/Home';
import HomeAudioBook from './page/HomeAudioBook';
import Landing from './page/Landing';
import Book from './page/Book';
import AudioBook from './page/AudioBook';
import Category from './page/CategoryView';
import CateView from './page/CateView';
import CateView2 from './page/CateView2';
import CateView2AudioBook from './page/CateView2AudioBook';
import Search from './page/Search';
import Search2 from './page/Search2';
import Search2AudioBook from './page/Search2AudioBook';
import Library from './page/Library';
import LibraryAudioBook from './page/LibraryAudioBook';
import ListView from './page/ListView';

import LibrarySignup from "./page/LibrarySignup";
import LibrarySearchMap from "./page/LibrarySearchMap";
import LibrarySearchConfirm from "./page/LibrarySearchConfirm";
import LibrarySignPromocode from "./page/LibrarySignPromocode";
import LibrarySignin from "./page/LibrarySignin";
import LibrarySigninAudioBook from "./page/LibrarySigninAudioBook";
import Alert from "./page/Alert";

import svbyyear from './page/sub/svbyyear';
import svbyauthor from './page/sub/svbyauthor';
import svbypublisher from './page/sub/svbypublisher';
import BookListViewByPub from './page/BookListViewByPub';
import BookListViewByAuthor from './page/BookListViewByAuthor';
import BookListView2 from "./page/BookListView2";
import BookListView2AudioBook from "./page/BookListView2AudioBook";
import BookListSuggestView from "./page/BookListSuggestView";
import BookListSuggestViewAudioBook from "./page/BookListSuggestViewAudioBook";
import BookListCategoryView_AudioBook from "./page/BookListCategoryViewAudioBook";
import Signin2 from "./page/Signin2";
import InfoView from "./page/InfoView";
import InfoViewAudioBook from "./page/InfoViewAudioBook";
import TagComplaint from "./page/TagComplaint";

class App extends Component {

    render() {
		//alert(JSON.stringify(this.props));
        return (
            
            <Router >
				<React.Fragment>
					<Route exact path="/" component={Landing}/>
					<Route path="/Home" component={Home}/>
					<Route path="/HomeAudioBook" component={HomeAudioBook}/>
					<Route path="/category/" component={Category} />
					<Route path="/cateview-nouse/" component={CateView} />
					<Route path="/cateview/" component={CateView2} />
					    <Route path="/cateview_audiobook/" component={CateView2AudioBook} />
					<Route path="/book/:bookid" component={Book} />
					<Route path="/bookfree/:bookid" component={Book} />
					    <Route path="/audiobook/:bookid" component={AudioBook} />


<Route path={['/http:', '/https:','/mailto:']} component={props => {
  window.location.replace(props.location.pathname.substr(1)) // substr(1) removes the preceding '/'
  return null
}}/>

					<Route path="/search11111/" component={Search} />
					<Route path="/search/" component={Search2} />
					<Route path="/search_audiobook/" component={Search2AudioBook} />
					<Route path="/library/" component={Library} />
					<Route path="/library_audiobook/" component={LibraryAudioBook} />
					<Route path="/list/" component={ListView} />
					    <Route path="/signup/" component={LibrarySignup} />
					    <Route path="/signin2/" component={Signin2} />
					<Route path="/signup-map/" component={LibrarySearchMap} />
					<Route path="/signup-confirm/" component={LibrarySearchConfirm} />
					<Route path="/signup-promocode/" component={LibrarySignPromocode} />
					<Route path="/signin/" component={LibrarySignin} />
					<Route path="/signin_audiobook/" component={LibrarySigninAudioBook} />
					<Route path="/alert/" component={Alert} />


					<Route path="/svpublisher/" component={svbypublisher} />
					<Route path="/svbyyear/" component={svbyyear} />
					<Route path="/svauthor/" component={svbyauthor} />
					<Route path="/blbypub/" component={BookListViewByPub} />
					<Route path="/blbyauthor/" component={BookListViewByAuthor} />
					<Route path="/BookList2" component={BookListView2} />
					<Route path="/BookListSuggest" component={BookListSuggestView} />

					    <Route path="/blbyauthor_audiobook/" component={BookListViewByAuthor} />
					    <Route path="/blbypub_audiobook/" component={BookListViewByPub} />
					    <Route path="/svauthor_audiobook/" component={svbyauthor} />
					    <Route path="/svpublisher_audiobook/" component={svbypublisher} />
					    <Route path="/BookList2AudioBook" component={BookListView2AudioBook} />

					<Route path="/BookListSuggest_AudioBook" component={BookListSuggestViewAudioBook} />
					<Route path="/BookListCategory_AudioBook" component={BookListCategoryView_AudioBook} />

					<Route path="/InfoView1" component={InfoView} />
					<Route path="/InfoView2" component={InfoView} />
					<Route path="/InfoView3" component={InfoView} />
					<Route path="/InfoView4" component={InfoView} />
					<Route path="/InfoView5" component={InfoView} />
					<Route path="/InfoView6" component={InfoView} />
					<Route path="/InfoView7" component={InfoView} />
					<Route path="/InfoView1_AudioBook" component={InfoViewAudioBook} />
					<Route path="/InfoView2_AudioBook" component={InfoViewAudioBook} />
					<Route path="/InfoView3_AudioBook" component={InfoViewAudioBook} />
					<Route path="/InfoView4_AudioBook" component={InfoViewAudioBook} />
					<Route path="/InfoView5_AudioBook" component={InfoViewAudioBook} />
					<Route path="/InfoView6_AudioBook" component={InfoViewAudioBook} />
					<Route path="/InfoView7_AudioBook" component={InfoViewAudioBook} />
					<Route path="/TagComplaint" component={TagComplaint} />
				</React.Fragment>
			</Router>
		);
	}
}

App.defaultProps = {
	headerTitle: '��å - �������'
};

export default App;
